// region statuses
export const STATUS_START = 'STATUS_START';
export const STATUS_LOADING = 'STATUS_LOADING';
export const STATUS_ERROR = 'STATUS_ERROR';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const SWITCH_TAB = 'SWITCH_TAB';

// region session
export const LOGIN = 'LOGIN';
export const CHECK_AUTH = 'CHECK_AUTH';
export const UPDATE_USER = 'UPDATE_USER';

// region invoices
export const RESET_INVOICE = 'RESET_INVOICE';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const GET_INVOICES = 'GET_INVOICES';

// region expenses
export const RESET_EXPENSE = 'RESET_EXPENSE';
export const CREATE_EXPENSE = 'CREATE_EXPENSE';
export const GET_EXPENSES = 'GET_EXPENSES';

// region activities
export const GET_ACTIVITIES = 'GET_ACTIVITIES';

// region nav
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
